import React from "react";
import { sharedCollaborators } from "../../data/collaborators";
import AllergicLivingLogo from "../../assets/allergic-living-logo.png";
import FareLogo from "../../assets/collaborators/fare-logo.png";
import SpokinLogo from "../../assets/collaborators/spokin-logo.png";
import AANLogo from "../../assets/collaborators/AAN-logo.png";
import CertistarLogo from "../../assets/collaborators/certistar-logo.png";
import MCDPHLogo from "../../assets/collaborators/maricopa-public-health.png";
import EqualEatsLogo from "../../assets/collaborators/equal-eats-logo.png";
import SnackSafelyLogo from "../../assets/collaborators/snack-safely-logo.png";
import FoxRestaurantConceptLogo from "../../assets/collaborators/fox-restaurant-concepts-logo.png";
import CampNotAWheezeLogo from "../../assets/collaborators/camp-not-a-wheeze-logo.png";
import NeffyLogo from "../../assets/collaborators/neffy-in-schools.svg";
import UAHSResearchCenterLogo from "../../assets/collaborators/uahs_asthma-airway-disease-research-center.png";
import AzAsthmaAndAllergyLogo from "../../assets/collaborators/az-asthma-and-allergy.png";
import PaCommonwealthLogo from "../../assets/collaborators/pa-commonwealth-logo.svg";
import LaraLogo from "../../assets/collaborators/lara.svg";
import NationalAssociationSchoolOfNursesLogo from "../../assets/collaborators/national-association-school-of-nurses.png";
import AllergyVoyageLogo from "../../assets/collaborators/allergy-voyage-logo.png";
import CollaboratorCard from "../../components/CollaboratorCard";
import CardDeck from "react-bootstrap/CardDeck";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { siteDarkGreen } from "../../providers/Theme";
import {
  PageContainer,
  Header,
  StyledVideo
} from "../shared.styled.components";
import AboutUsPageNav from "../../components/AboutUsPageNav";
import Donors from "../../components/Donors";
import { VideoContainer } from "./styled.components";

const sc = (id: string) => sharedCollaborators.find(c => c.id === id)!;

const Collaborators: React.FC = () => {
  return (
    <PageContainer>
      <Container className="text-center my-5">
        <Header color={siteDarkGreen}>Meet Our Collaborators</Header>
      </Container>

      <CardDeck className="d-flex flex-wrap justify-content-center">
        <CollaboratorCard
          src={sc("ua-mezcoph").logo}
          title={sc("ua-mezcoph").name}
          content={sc("ua-mezcoph").description}
          link={sc("ua-mezcoph").link}
        />

        <CollaboratorCard
          src={MCDPHLogo}
          title="Maricopa County Department of Public Health"
          content="Our mission at Maricopa County Public Health is to protect and promote the health and well-being of all of our residents and visitors."
          link="https://www.maricopa.gov/5302/Public-Health"
        />

        <CollaboratorCard
          src={sc("pcdh").logo}
          title={sc("pcdh").name}
          content={sc("pcdh").description}
          link={sc("pcdh").link}
        />

        <CollaboratorCard
          src={sc("wrphtc").logo}
          title={sc("wrphtc").name}
          content={sc("wrphtc").description}
          link={sc("wrphtc").link}
        />

        <CollaboratorCard
          src={FareLogo}
          title="FARE"
          content="FARE works to enhance the access of individuals with food allergies to safe food, effective emergency treatment and accurate health information."
          link="https://www.foodallergy.org/"
        />

        <CollaboratorCard
          src={AllergicLivingLogo}
          title="Allergic Living"
          content="The authoritative voice on food allergy news."
          link="https://www.allergicliving.com/"
        />

        <CollaboratorCard
          src={NeffyLogo}
          title="Neffy"
          content="Neffy 2 mg is a nasal spray used to treat life-threatening, allergic emergencies including anaphylaxis. neffy is the first- and-only needle-free epinephrine nasal spray for serious allergic reactions."
          link="https://www.neffy.com/community-programs/"
        />

        <CollaboratorCard
          src={CertistarLogo}
          title="Certistar"
          content="Take the guesswork out of food allergies. A mission to protect and improve the safety and dining experience of men, women and children vulnerable to food allergens."
          link="https://certistar.com/"
        />

        <CollaboratorCard
          src={AANLogo}
          title="Allergy & Asthma Network"
          content="Allergy & Asthma Network unites and advocates on behalf of 60 million Americans with asthma, allergies and related conditions."
          link="https://allergyasthmanetwork.org/"
        />

        <CollaboratorCard
          src={FoxRestaurantConceptLogo}
          title="Fox Restaurant Concepts"
          content="Fox Restaurant Concepts believes the best stories are shared over food. We challenge ourselves to find ways to make our best ideas even better and our people and guests are at the heart of all we do."
          link="https://www.foxrc.com/"
        />

        <CollaboratorCard
          src={UAHSResearchCenterLogo}
          title="Asthma Disease & Research Center"
          content="Asthma & Airway Disease Research Center is an interdisciplinary Center of Excellence at the University Of Arizona dedicated to research, clinical care, medical education, and community service in the areas of adult and pediatric pulmonary medicine."
          link="https://airways.uahs.arizona.edu/"
        />

        <CollaboratorCard
          src={NationalAssociationSchoolOfNursesLogo}
          title="National Association of School Nurses"
          content="NASN works to optimize student health, safety and learning, it is the position of the National Association of School Nurses that a professional registered school nurse be present in every school all day, every day."
          link="https://www.nasn.org/home"
        />

        <CollaboratorCard
          src={sc("visit-mesa").logo}
          title={sc("visit-mesa").name}
          content={sc("visit-mesa").description}
          link={sc("visit-mesa").link}
        />

        <CollaboratorCard
          src={LaraLogo}
          title="State of Michigan Department of Licensing and Regulatory Affairs"
          content="To be national leaders that partner with people and businesses to improve the lives of Michigan residents through an engaged and inclusive workforce."
          link="https://www.michigan.gov/lara"
        />

        <CollaboratorCard
          src={PaCommonwealthLogo}
          title="Pennsylvania Department of Health Bureau of EMS"
          content="The Department of Health is the lead agency for emergency medical services (EMS) in the commonwealth. The Department’s Bureau of Emergency Medical Services is responsible for the statewide development and coordination of a comprehensive system to prevent and reduce premature death and disability."
          link="https://www.pa.gov/agencies/health/healthcare-and-public-health-professionals/ems/epi-pen-training.html"
        />

        <CollaboratorCard
          src={AzAsthmaAndAllergyLogo}
          title="Arizona Allergy and Asthma"
          content="Mission is to provide exceptional care and expertise to patients suffering from allergies, immunological disorders, and asthma. Our team of highly skilled physician specialists, all board certified by the American Board of Allergy and Immunology, is dedicated to improving the lives of our patients and serving as leaders in our field."
          link="https://azsneeze.com/"
        />

        <CollaboratorCard
          src={EqualEatsLogo}
          title="Equal Eats"
          content="Our mission is to provide solutions and tools to help people living with dietary restrictions communicate with the food service industry effectively, accurately, and conveniently."
          link="https://equaleats.com/"
        />

        <CollaboratorCard
          src={SnackSafelyLogo}
          title="Snack Safely"
          content="SnackSafely.com provides resources to help families, schools, and organizations identify safe food options for those with food allergies. Their Safe Snack Guide and manufacturer partnership program deliver accurate, up-to-date allergen information to promote inclusion and protect individuals at risk."
          link="https://snacksafely.com/"
        />

        <CollaboratorCard
          src={CampNotAWheezeLogo}
          title="Camp Not-A-Wheeze"
          content="Celebrating more than 35 years, Camp Not-A-Wheeze is the premiere camp for children with asthma or allergic conditions in the state of Arizona. In a traditional camp setting asthma and allergy education is integrated with recreational camp activities. This empowers children to exercise control over their allergy or chronic lung condition."
          link="https://www.campnotawheeze.org"
        />

        <CollaboratorCard
          src={SpokinLogo}
          title="Spokin"
          content="Meet the best food allergy app ever. Spokin saves you time to make life with food allergies easier."
          link="https://www.spokin.com/"
        />

        <CollaboratorCard
          src={AllergyVoyageLogo}
          title="Allergy Voyage"
          content="Dine Safely, with Allergy Voyage. Allergy Voyage is a digital concierge service that hosts menus for individuals with dietary restrictions to view, helping them feel safer and confident when dining, simultaneously increasing food service provider revenue. We believe that food provides a human connection, allowing communication across boundaries. Individuals with food allergies should not be excluded from this conversation."
          link="https://allergyvoyage.com/"
        />
      </CardDeck>

      <Container fluid="md" className="text-center">
        <Header color={siteDarkGreen}>Our Impact</Header>
        <Row className="justify-content-center my-1">
          <Col>
            <VideoContainer>
              <StyledVideo
                className="embed-responsive-item"
                src="https://player.vimeo.com/video/1060206530"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="video"
              />
            </VideoContainer>
          </Col>
        </Row>
      </Container>

      <Donors />

      <AboutUsPageNav currentPage="collaborators" />
    </PageContainer>
  );
};

export default Collaborators;
